import React, { useEffect, useState } from 'react';



import {Elements, useStripe, useElements} from '@stripe/react-stripe-js';

import {loadStripe} from "@stripe/stripe-js";
import StripeCardInput from "./stripe_card_input";

const stripePromise = loadStripe('pk_test_IecX85YKDNvzr22qiKWBDbf0');
// const stripePromise = loadStripe('pk_test_IecX85YKDNvzr22qiKWBDbf0');


export default function Stripe({onFinish}) {
    // Get States from Redux Store

    return (
        <Elements stripe={stripePromise}>
            <StripeCardInput onFinish={onFinish} />
        </Elements>
    );
}
